import { render, staticRenderFns } from "./HeatMaps.vue?vue&type=template&id=c03b9960&scoped=true&lang=pug"
import script from "./HeatMaps.vue?vue&type=script&lang=js"
export * from "./HeatMaps.vue?vue&type=script&lang=js"
import style0 from "./HeatMaps.vue?vue&type=style&index=0&id=c03b9960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b9960",
  null
  
)

export default component.exports